var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840.52 658.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d, .baf6d728-a55b-4d8c-a7cb-14c1a0c0e794, .be0e5f6c-2e4d-4204-9885-29af3670c290, .f83144d7-86a1-4655-877f-aa8f9a9c010a {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .f83144d7-86a1-4655-877f-aa8f9a9c010a {\n        stroke-width: 6.32px;\n      }\n\n      .a2a8b5ce-b82b-4f70-b45f-17732f359ec1 {\n        fill: #231f20;\n      }\n\n      .be0e5f6c-2e4d-4204-9885-29af3670c290 {\n        stroke-width: 7.89px;\n      }\n\n      .ace6b64d-8613-49f4-938e-a56f99f60451 {\n        fill: #92d4cd;\n      }\n\n      .e8f641ad-c829-4211-ad45-2e72a2f5fc67 {\n        fill: #ee6e51;\n      }\n\n      .b92d8fd6-ef40-4ec2-90c5-aad310278d2d {\n        fill: #f4beb2;\n      }\n\n      .a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d {\n        stroke-width: 7.37px;\n      }\n\n      .baf6d728-a55b-4d8c-a7cb-14c1a0c0e794 {\n        stroke-width: 6.24px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "space") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f12310ea-c0e4-4780-80a7-7f6b579873e8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac7ac440-04be-4880-804a-f834eb7b2d77",
    "data-name": "colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M355.14,439.22s-41.38,2.46-51.88,54.71"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 299.81,
    cy: 497.02,
    rx: 8.58,
    ry: 10.2,
    transform: "translate(-276.51 566.12) rotate(-65.74)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 428,
    cy: 648.24,
    rx: 8.58,
    ry: 10.2,
    transform: "translate(-156.29 136.38) rotate(-15.35)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 497.3,
    cy: 626.98,
    rx: 10.2,
    ry: 8.58,
    transform: "translate(-161.47 1081.33) rotate(-86.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M476.9,426.37s41.62-.79,52.11,51.46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 532.47,
    cy: 480.92,
    rx: 10.2,
    ry: 8.58,
    transform: "translate(-150.59 261.27) rotate(-24.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 368.48,
    cy: 321.54,
    r: 9.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 502.71,
    cy: 305.09,
    r: 9.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M474.47,408c.8-6.44,3.57-10.4,6.7-13.94a32.24,32.24,0,0,1,12.43-8.5q5.49-2.14,10.87-4.45a72.86,72.86,0,0,0,19.83-12.5l.1-.09a143.87,143.87,0,0,0,43.46-140.68,146.45,146.45,0,0,0-6.09-19.23q-1.83-4.62-3.91-9.13c-16.15-36.77-41.49-73.09-81.51-84.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ace6b64d-8613-49f4-938e-a56f99f60451",
    d: "M356.15,427.15c-5.23,49.39-1.86,149.45,99.47,117.07,52.15-16.67,32.45-89.88,21.13-118.24l-55.42,9.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M334.06,144.06a147.18,147.18,0,0,0-34.73,51q-2.31,5.47-4.17,11.12c-1.56,3.94-3,7.92-4.3,12a144.21,144.21,0,0,0,20,127.24A103.74,103.74,0,0,0,343,374.09c9.23,5.43,20.39,15.25,16.8,29.78-.38,1.53-.66,2.73-1.12,5.29"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    cx: 398.58,
    cy: 95.62,
    r: 18.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "e8f641ad-c829-4211-ad45-2e72a2f5fc67",
    d: "M466.5,55.5a9.92,9.92,0,0,0-15.61-3L413.94,86a18.1,18.1,0,0,0-31.8,2L334.75,68.72a8.6,8.6,0,0,0-11.83,7.81c-.77,37.58,6.44,58.91,12.42,70a9.92,9.92,0,0,0,15.73,2.37l38.17-37.79A18,18,0,0,0,410.75,109l53,24.26A8.59,8.59,0,0,0,475.88,126C478.28,88.49,472,66.87,466.5,55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M387.39,80.93c.61-18.2,4.26-36.77,18.53-51a182,182,0,0,0,0,49.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M416.71,550.51s-9.18,56,11.29,97.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M476.41,531.36s22.85,32.71,20.76,91.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b92d8fd6-ef40-4ec2-90c5-aad310278d2d",
    d: "M735.38,580l25.4-5.37c4.83-1,7.47-7.53,4.49-11.06L743,537.27a5.91,5.91,0,0,1-1.16-4.78l5.26-33.09c.84-5.28-4.12-8.31-8.44-5.14l-26.33,19.31a5.93,5.93,0,0,1-4.79,1.15l-36-8.3c-4.51-1-9.09,4.28-7.78,9.05l7.61,27.87a7.64,7.64,0,0,1-2.29,7.31l-22.24,20.94c-4,3.73-3.06,10.13,1.54,10.89l40,.93a4.59,4.59,0,0,1,3,1.82l19.13,35.13c2.77,3.74,8.88,1.62,10.38-3.61l9-31.37A7.62,7.62,0,0,1,735.38,580Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b92d8fd6-ef40-4ec2-90c5-aad310278d2d",
    d: "M81.72,97.42,91,79.12c1.77-3.49-.92-8.34-4.58-8.25l-27.22.65a4.66,4.66,0,0,1-3.52-1.66L37.92,50.22c-2.84-3.13-7.16-1.58-7.35,2.64L29.4,78.65a4.65,4.65,0,0,1-1.66,3.51l-22.95,18c-2.87,2.26-1.86,7.71,1.72,9.27l20.93,9.13a6,6,0,0,1,3.36,5l1.87,24.08c.33,4.29,4.72,6.9,7.46,4.45L60.53,128a3.61,3.61,0,0,1,2.6-.94l31.1,5.64c3.68.15,5.41-4.66,2.93-8.18l-14.83-21.1A6,6,0,0,1,81.72,97.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b92d8fd6-ef40-4ec2-90c5-aad310278d2d",
    d: "M747.37,181.91l9.16-7.06c1.74-1.34,1.54-4.46-.34-5.3l-14-6.26a2.65,2.65,0,0,1-1.39-1.7l-4.28-14.29a2.29,2.29,0,0,0-4.38-.43L725.3,159.7a2.6,2.6,0,0,1-1.69,1.38l-16,3.62c-2,.46-2.82,3.48-1.38,5.14l8.44,9.71a3.39,3.39,0,0,1,.49,3.37l-4.88,12.7c-.87,2.27.73,4.66,2.72,4.07l16.22-7.34a2.08,2.08,0,0,1,1.55.15l14.46,10.41c1.83,1,3.88-1.07,3.47-3.46l-2.44-14.33A3.44,3.44,0,0,1,747.37,181.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b92d8fd6-ef40-4ec2-90c5-aad310278d2d",
    d: "M206.54,445.39l3.48-8.81c.66-1.68-.79-3.79-2.46-3.59l-12.48,1.47a2.14,2.14,0,0,1-1.69-.61l-9-8.26a1.87,1.87,0,0,0-3.26,1.53l.57,11.9a2.2,2.2,0,0,1-.61,1.69L171.31,450c-1.22,1.17-.53,3.63,1.19,4.19l10,3.3a2.78,2.78,0,0,1,1.76,2.16l1.89,11c.34,1.95,2.47,3,3.63,1.72l8.33-12a1.73,1.73,0,0,1,1.15-.54l14.54,1.26c1.7-.09,2.28-2.38,1-3.89l-7.72-9.06A2.77,2.77,0,0,1,206.54,445.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d",
    cx: 414.66,
    cy: 210.26,
    r: 206.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d",
    d: "M350.14,406.56a207.68,207.68,0,0,0,130.45-.48v13.77a6.81,6.81,0,0,1-4.81,6.51,207.95,207.95,0,0,1-120.79.45,6.82,6.82,0,0,1-4.85-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d",
    d: "M350.14,406.56a207.68,207.68,0,0,0,130.45-.48v13.77a6.81,6.81,0,0,1-4.81,6.51,207.95,207.95,0,0,1-120.79.45,6.82,6.82,0,0,1-4.85-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b92d8fd6-ef40-4ec2-90c5-aad310278d2d",
    d: "M825.28,290l10-2.66c1.9-.51,2.81-3.15,1.55-4.49l-9.38-10a2.38,2.38,0,0,1-.56-1.88l1.39-13.25a2,2,0,0,0-3.45-1.87l-10.06,8.22a2.34,2.34,0,0,1-1.88.56l-14.47-2.54c-1.81-.32-3.52,1.89-2.9,3.76l3.61,10.91a3,3,0,0,1-.76,2.95L790,288.55c-1.5,1.57-1,4.09.84,4.29l15.9-.46a1.8,1.8,0,0,1,1.22.66l8.33,13.55c1.18,1.43,3.57.46,4-1.65l2.93-12.65A3.07,3.07,0,0,1,825.28,290Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bab411d1-bb07-4ffc-b234-e7cede88ba94",
    "data-name": "line art"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M355.14,439.22s-41.38,2.46-51.88,54.71"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 299.81,
    cy: 497.02,
    rx: 8.58,
    ry: 10.2,
    transform: "translate(-276.51 566.12) rotate(-65.74)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 428,
    cy: 648.24,
    rx: 8.58,
    ry: 10.2,
    transform: "translate(-156.29 136.38) rotate(-15.35)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 497.3,
    cy: 626.98,
    rx: 10.2,
    ry: 8.58,
    transform: "translate(-161.47 1081.33) rotate(-86.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M476.9,426.37s41.62-.79,52.11,51.46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 532.47,
    cy: 480.92,
    rx: 10.2,
    ry: 8.58,
    transform: "translate(-150.59 261.27) rotate(-24.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 368.48,
    cy: 321.54,
    r: 9.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a2a8b5ce-b82b-4f70-b45f-17732f359ec1",
    cx: 502.71,
    cy: 305.09,
    r: 9.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M474.47,408c.8-6.44,3.57-10.4,6.7-13.94a32.24,32.24,0,0,1,12.43-8.5q5.49-2.14,10.87-4.45a72.86,72.86,0,0,0,19.83-12.5l.1-.09a143.87,143.87,0,0,0,43.46-140.68,146.45,146.45,0,0,0-6.09-19.23q-1.83-4.62-3.91-9.13c-16.15-36.77-41.49-73.09-81.51-84.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M356.15,427.15c-5.23,49.39-1.86,149.45,99.47,117.07,52.15-16.67,32.45-89.88,21.13-118.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M334.06,144.06a147.18,147.18,0,0,0-34.73,51q-2.31,5.47-4.17,11.12c-1.56,3.94-3,7.92-4.3,12a144.21,144.21,0,0,0,20,127.24A103.74,103.74,0,0,0,343,374.09c9.23,5.43,20.39,15.25,16.8,29.78-.38,1.53-.66,2.73-1.12,5.29"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    cx: 398.58,
    cy: 95.62,
    r: 18.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M466.5,55.5a9.92,9.92,0,0,0-15.61-3L413.94,86a18.1,18.1,0,0,0-31.8,2L334.75,68.72a8.6,8.6,0,0,0-11.83,7.81c-.77,37.58,6.44,58.91,12.42,70a9.92,9.92,0,0,0,15.73,2.37l38.17-37.79A18,18,0,0,0,410.75,109l53,24.26A8.59,8.59,0,0,0,475.88,126C478.28,88.49,472,66.87,466.5,55.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be0e5f6c-2e4d-4204-9885-29af3670c290",
    d: "M387.39,80.93c.61-18.2,4.26-36.77,18.53-51a182,182,0,0,0,0,49.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M416.71,550.51s-9.18,56,11.29,97.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f83144d7-86a1-4655-877f-aa8f9a9c010a",
    d: "M476.41,531.36s22.85,32.71,20.76,91.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "baf6d728-a55b-4d8c-a7cb-14c1a0c0e794",
    d: "M735.38,580l25.4-5.37c4.83-1,7.47-7.53,4.49-11.06L743,537.27a5.91,5.91,0,0,1-1.16-4.78l5.26-33.09c.84-5.28-4.12-8.31-8.44-5.14l-26.33,19.31a5.93,5.93,0,0,1-4.79,1.15l-36-8.3c-4.51-1-9.09,4.28-7.78,9.05l7.61,27.87a7.64,7.64,0,0,1-2.29,7.31l-22.24,20.94c-4,3.73-3.06,10.13,1.54,10.89l40,.93a4.59,4.59,0,0,1,3,1.82l19.13,35.13c2.77,3.74,8.88,1.62,10.38-3.61l9-31.37A7.62,7.62,0,0,1,735.38,580Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "baf6d728-a55b-4d8c-a7cb-14c1a0c0e794",
    d: "M81.72,97.42,91,79.12c1.77-3.49-.92-8.34-4.58-8.25l-27.22.65a4.66,4.66,0,0,1-3.52-1.66L37.92,50.22c-2.84-3.13-7.16-1.58-7.35,2.64L29.4,78.65a4.65,4.65,0,0,1-1.66,3.51l-22.95,18c-2.87,2.26-1.86,7.71,1.72,9.27l20.93,9.13a6,6,0,0,1,3.36,5l1.87,24.08c.33,4.29,4.72,6.9,7.46,4.45L60.53,128a3.61,3.61,0,0,1,2.6-.94l31.1,5.64c3.68.15,5.41-4.66,2.93-8.18l-14.83-21.1A6,6,0,0,1,81.72,97.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "baf6d728-a55b-4d8c-a7cb-14c1a0c0e794",
    d: "M747.37,181.91l9.16-7.06c1.74-1.34,1.54-4.46-.34-5.3l-14-6.26a2.65,2.65,0,0,1-1.39-1.7l-4.28-14.29a2.29,2.29,0,0,0-4.38-.43L725.3,159.7a2.6,2.6,0,0,1-1.69,1.38l-16,3.62c-2,.46-2.82,3.48-1.38,5.14l8.44,9.71a3.39,3.39,0,0,1,.49,3.37l-4.88,12.7c-.87,2.27.73,4.66,2.72,4.07l16.22-7.34a2.08,2.08,0,0,1,1.55.15l14.46,10.41c1.83,1,3.88-1.07,3.47-3.46l-2.44-14.33A3.44,3.44,0,0,1,747.37,181.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "baf6d728-a55b-4d8c-a7cb-14c1a0c0e794",
    d: "M206.54,445.39l3.48-8.81c.66-1.68-.79-3.79-2.46-3.59l-12.48,1.47a2.14,2.14,0,0,1-1.69-.61l-9-8.26a1.87,1.87,0,0,0-3.26,1.53l.57,11.9a2.2,2.2,0,0,1-.61,1.69L171.31,450c-1.22,1.17-.53,3.63,1.19,4.19l10,3.3a2.78,2.78,0,0,1,1.76,2.16l1.89,11c.34,1.95,2.47,3,3.63,1.72l8.33-12a1.73,1.73,0,0,1,1.15-.54l14.54,1.26c1.7-.09,2.28-2.38,1-3.89l-7.72-9.06A2.77,2.77,0,0,1,206.54,445.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "baf6d728-a55b-4d8c-a7cb-14c1a0c0e794",
    d: "M825.28,290l10-2.66c1.9-.51,2.81-3.15,1.55-4.49l-9.38-10a2.38,2.38,0,0,1-.56-1.88l1.39-13.25a2,2,0,0,0-3.45-1.87l-10.06,8.22a2.34,2.34,0,0,1-1.88.56l-14.47-2.54c-1.81-.32-3.52,1.89-2.9,3.76l3.61,10.91a3,3,0,0,1-.76,2.95L790,288.55c-1.5,1.57-1,4.09.84,4.29l15.9-.46a1.8,1.8,0,0,1,1.22.66l8.33,13.55c1.18,1.43,3.57.46,4-1.65l2.93-12.65A3.07,3.07,0,0,1,825.28,290Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d",
    cx: 414.66,
    cy: 210.26,
    r: 206.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d",
    d: "M350.14,406.56a207.68,207.68,0,0,0,130.45-.48v13.77a6.81,6.81,0,0,1-4.81,6.51,207.95,207.95,0,0,1-120.79.45,6.82,6.82,0,0,1-4.85-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a6b0f32c-7dba-4fb4-af55-3b58ebdc1c2d",
    d: "M350.14,406.56a207.68,207.68,0,0,0,130.45-.48v13.77a6.81,6.81,0,0,1-4.81,6.51,207.95,207.95,0,0,1-120.79.45,6.82,6.82,0,0,1-4.85-6.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.2393e9533253d7f904b15f3144848b11.svg";
export { ForwardRef as ReactComponent };